import script from "./ErrorPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ErrorPage.vue?vue&type=script&lang=ts&setup=true"

import "./ErrorPage.vue?vue&type=style&index=0&id=6ed3a84c&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ed3a84c"]])

export default __exports__